// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { UserAttributesDTO } from './user-attributes-dto';
import { UserFeatureFlagsDTO } from './user-feature-flags-dto';

/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email: string;
    /**
     * 
     * @type {UserAttributesDTO}
     * @memberof UserDTO
     */
    attributes?: UserAttributesDTO;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    userTypeId: UserDTOUserTypeIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDTO
     */
    internalRoles?: Array<UserDTOInternalRolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    legacyId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    intercomUserHash?: string;
    /**
     * 
     * @type {UserFeatureFlagsDTO}
     * @memberof UserDTO
     */
    featureFlags?: UserFeatureFlagsDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserDTO
     */
    hasAuthDisabled: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UserDTOUserTypeIdEnum {
    AGENT = 'AGENT',
    ARBITRATOR = 'ARBITRATOR',
    LANDLORD = 'LANDLORD',
    TENANT = 'TENANT',
    INTERNAL = 'INTERNAL',
    MACHINE = 'MACHINE'
}
/**
    * @export
    * @enum {string}
    */
export enum UserDTOInternalRolesEnum {
    FINANCEALL = 'FINANCE_ALL',
    FINANCEINDIVIDUAL = 'FINANCE_INDIVIDUAL',
    PAYMENTPLANCREATE = 'PAYMENT_PLAN_CREATE',
    PAYMENTPLANDELETE = 'PAYMENT_PLAN_DELETE',
    INTERNALREPORTSALES = 'INTERNAL_REPORT_SALES',
    MANAGEORGANIZATIONACCOUNTMANAGER = 'MANAGE_ORGANIZATION_ACCOUNT_MANAGER',
    MANAGEORGANIZATIONUSERROLES = 'MANAGE_ORGANIZATION_USER_ROLES',
    MANAGEORGANIZATIONGROUPS = 'MANAGE_ORGANIZATION_GROUPS',
    MANAGEORGANIZATIONBRANDING = 'MANAGE_ORGANIZATION_BRANDING',
    BULKIMPORT = 'BULK_IMPORT',
    CLAIMUPDATEAUTOCHARGE = 'CLAIM_UPDATE_AUTO_CHARGE',
    CLAIMITEMCORRECTIVECHANGE = 'CLAIM_ITEM_CORRECTIVE_CHANGE',
    CLAIMDELETE = 'CLAIM_DELETE',
    BANKTRANSACTIONIMPORT = 'BANK_TRANSACTION_IMPORT',
    CARSPAYMENTIMPORT = 'CARS_PAYMENT_IMPORT',
    SUPPLIERPAYMENTSIMPORT = 'SUPPLIER_PAYMENTS_IMPORT',
    UPDATEORGANIZATIONPRICINGRULE = 'UPDATE_ORGANIZATION_PRICING_RULE',
    UPDATEORGANIZATIONPOLICYCOVERCAP = 'UPDATE_ORGANIZATION_POLICY_COVER_CAP',
    UPDATEORGANIZATIONCOMMISSIONRULE = 'UPDATE_ORGANIZATION_COMMISSION_RULE',
    UPDATEORGANIZATIONHUBSPOTID = 'UPDATE_ORGANIZATION_HUBSPOT_ID',
    UPDATEORGANIZATIONNAME = 'UPDATE_ORGANIZATION_NAME',
    PAYMENTPLANINSTALMENTDELETE = 'PAYMENT_PLAN_INSTALMENT_DELETE',
    PAYMENTPLANDELETEFORCE = 'PAYMENT_PLAN_DELETE_FORCE',
    PAYMENTPLANINSTALMENTDESIGNER = 'PAYMENT_PLAN_INSTALMENT_DESIGNER',
    EVIDENCEWORKSPACE = 'EVIDENCE_WORKSPACE',
    EVIDENCEWORKSPACEADVANCED = 'EVIDENCE_WORKSPACE_ADVANCED',
    READDOCUMENTANALYSIS = 'READ_DOCUMENT_ANALYSIS',
    MANAGEBLOCKEDTENANTS = 'MANAGE_BLOCKED_TENANTS',
    UPDATEORGANIZATIONINVENTORYCONFIRMATIONDELAY = 'UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY',
    CLAIMUPDATEBANKTRANSACTIONSENABLEDAT = 'CLAIM_UPDATE_BANK_TRANSACTIONS_ENABLED_AT',
    CLAIMEXTENDRESPONSEDEADLINE = 'CLAIM_EXTEND_RESPONSE_DEADLINE'
}



